module.exports = __webpack_public_path__ + "static/media/pointer-right.47406ede.svg";